import { ROLES } from '@/config/roles'
import { clearChildMissionContext } from '@/utils/missionUtils'

export function normalizeRole(role) {
  if (typeof role !== 'string') return null
  return role.trim().toUpperCase()
}

export function isSchoolStudentAccount(userRole, currentUser) {
  const role = normalizeRole(userRole) || normalizeRole(currentUser?.role)
  return role === ROLES.STUDENT
}

export function clearChildSessionKeys() {
  if (typeof window === 'undefined') return false
  let changed = false
  if (clearChildMissionContext()) {
    changed = true
  }
  if (localStorage.getItem('selectedProfile')) {
    localStorage.removeItem('selectedProfile')
    changed = true
  }
  return changed
}

export function normalizeOwnedItemMap(raw) {
  if (!raw) {
    return { ownedItems: {}, ownedItemIds: new Set() }
  }

  if (Array.isArray(raw)) {
    const ownedItems = {}
    raw.forEach((itemId) => {
      if (typeof itemId === 'string' && itemId) {
        ownedItems[itemId] = { purchasedAt: null, priceCoins: 0 }
      }
    })
    return { ownedItems, ownedItemIds: new Set(Object.keys(ownedItems)) }
  }

  if (typeof raw === 'object') {
    return {
      ownedItems: raw,
      ownedItemIds: new Set(Object.keys(raw))
    }
  }

  return { ownedItems: {}, ownedItemIds: new Set() }
}

export function pickRewardTotals(data) {
  if (!data || typeof data !== 'object') {
    return { totalCoins: 0, totalExp: 0 }
  }
  return {
    totalCoins: Number(data.totalCoins) || 0,
    totalExp: Number(data.totalExp) || 0
  }
}
